import { useMemo } from "react";
import { useSelector } from "react-redux";

import { Roles } from "@/shared/utils/constants";
import OrganizationTable from "@/features/organizations/list/components/OrganizationTable";
import { selectCurrentUser } from "@/redux/authentication/selectors";

import "./styles.css";
import { OrganizationFiltersState } from "@/features/organizations/list/types";

const OrganizationList = () => {
  const currentUser = useSelector(selectCurrentUser);

  const tableDetails = useMemo(() => {
    if (!currentUser) return;

    const columns = [
      "name",
      "country",
      "chapter",
      "communicatingStatus",
      "communityRoles",
    ];
    const filters = [
      "search",
      "countries",
      "chapters",
      "communityRoles",
      "communicatingStatus",
    ];
    const defaultFilters: Partial<OrganizationFiltersState> = {
      isInternal: false,
    };
    if (currentUser.role === Roles.ADMIN.value) {
      columns.unshift("externalId");
      columns.push("admin", "registrationStatus", "actions");
      filters.unshift("externalId");
      filters.push("registrationStatus");
    }

    return {
      columns,
      filters,
      defaultFilters,
    };
  }, [currentUser]);

  return (
    <div className="organizations-list-container">
      {tableDetails && (
        <OrganizationTable
          columnNames={tableDetails.columns}
          filterNames={tableDetails.filters}
          defaultFilters={tableDetails.defaultFilters}
        />
      )}
    </div>
  );
};

export default OrganizationList;
